<div class="p-4 flex flex-col gap-2 items-center justify-center">
    <img class="animate-pulse animate-infinite animate-duration-[2000ms] mx-auto max-w-sm" src="assets/images/logo/purso_logo_primary.svg" alt="Purso Logo">
    @if(data?.error && data.error()){
        <span class="self-center text-primary font-bold first-letter:capitalize"> {{ data.error() | translate}} </span>
    } @else {
        <span class="self-center text-primary font-bold first-letter:capitalize"> {{ data.labelKey | translate}}...</span>
    }
</div>
